import { useModuleStrings } from '@platform/modularity/useModuleStrings';
import { buildMenu } from './buildMenu';
import type { ITypeSectionItemsProps } from './ITypeSectionItemsProps';
import { MenuEntryLink } from './MenuEntryLink';
import { visibleSections } from './menuEntries';
import { menuGroupsFor } from './moduleSections';
import { useActiveEntryKey } from './useActiveEntryKey';
import { useMenuFacets } from './useMenuFacets';

/**
 * Пункти розгорнутого розділу типу запису: усі групи його меню одним списком (без вкладених груп), з живими лічильниками. Монтується лише
 * в розгорнутому розділі, тож статистику згорнутих типів не запитуємо.
 */
export function TypeSectionItems({ ws, moduleKey, moduleName, rt, planning }: ITypeSectionItemsProps) {
  const strings = useModuleStrings();
  const facets = useMenuFacets(ws, rt);
  const sections = buildMenu(menuGroupsFor(rt, planning), facets, strings, moduleName);
  const active = useActiveEntryKey(rt.key, sections);
  return (
    <>
      {visibleSections(sections).flatMap((s) => s.entries).map((e) => (
        <MenuEntryLink key={e.key} ws={ws} moduleKey={moduleKey} rtKey={rt.key} entry={e} active={e.key === active} />
      ))}
    </>
  );
}
